module.exports = __webpack_public_path__ + "assets/img/hero-grid-overlay.890f5154.png";